import React from 'react';
import { withRouter } from 'react-router-dom';
import { Formik } from 'formik';
import { FormattedMessage, injectIntl } from 'react-intl';
import axios from 'axios';

const ModalSituacao = (props) => {

   const intl = props.intl;

   const placeholder1 = intl.formatMessage({
      id: "home.modal_situ.placeholder1"
   });
   const placeholder2 = intl.formatMessage({
      id: "home.modal_situ.placeholder2"
   });
   const placeholder3 = intl.formatMessage({
      id: "home.modal_situ.placeholder3"
   });
   const placeholder4 = intl.formatMessage({
      id: "home.modal_situ.placeholder4"
   });
   const placeholder5 = intl.formatMessage({
      id: "home.modal_situ.placeholder5"
   });
   
   function enviarDados(event, values){
      event.preventDefault();
      axios.post('https://covidback19.herokuapp.com/denuncias', {respondida: 0, ...values}).then(() => {
         alert(intl.formatMessage({
            id: "home.modal_situ.button_submit"
         }));
         props.history.push('/');
      });

   }

   return(
	   <div className="col-md-12">
            <div className="modal__header">
               <h1><FormattedMessage id="home.modal_situ.h1"/></h1>
               <h4><FormattedMessage id="home.modal_situ.h4"/></h4>
               <p><FormattedMessage id="home.modal_situ.p"/></p>
            </div>
	  <Formik
                  
            initialValues={{ 
               nome: '', 
               email: '', 
               vulnerabilidade: '',
               data: '',
               idade: '',
               periodo: '',
               endereco: ''
            }}
         >
            {({
               values,
               errors,
               touched,
               handleChange,
               handleBlur,
               handleSubmit,
               isSubmitting,
            }) => (
               <form className="form" onSubmit={event => {enviarDados(event, values)}}>
                  <div className="row">
                     
                     <div className="col-md-12">
                        <div className="form-group">
                           <label className="form-label" htmlFor="vulnerabilidade"><FormattedMessage id="home.modal_situ.label1"/><span className="form-required">*</span></label>
                           <select
                              className={`form-input ${ errors.vulnerabilidade && touched.vulnerabilidade ? 'is-invalid' : '' }`}
                              name="vulnerabilidade"
                              placeholder="Tipo de vulnerabilidade presenciada por você"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.vulnerabilidade}
                           >
                              <option value={ intl.formatMessage({id: "home.modal_situ.option1"}) }>{ intl.formatMessage({id: "home.modal_situ.option1"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_situ.option2"}) }>{ intl.formatMessage({id: "home.modal_situ.option2"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_situ.option3"}) }>{ intl.formatMessage({id: "home.modal_situ.option3"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_situ.option4"}) }>{ intl.formatMessage({id: "home.modal_situ.option4"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_situ.option5"}) }>{ intl.formatMessage({id: "home.modal_situ.option5"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_situ.option6"}) }>{ intl.formatMessage({id: "home.modal_situ.option6"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_situ.option7"}) }>{ intl.formatMessage({id: "home.modal_situ.option7"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_situ.option8"}) }>{ intl.formatMessage({id: "home.modal_situ.option8"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_situ.option9"}) }>{ intl.formatMessage({id: "home.modal_situ.option9"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_situ.option10"}) }>{ intl.formatMessage({id: "home.modal_situ.option10"}) }</option>
                              <option value={ intl.formatMessage({id: "home.modal_situ.option11"}) }>{ intl.formatMessage({id: "home.modal_situ.option11"}) }</option>
                           </select>
                        </div>
                     </div>

                     <div className="col-md-12">
                        <div className="form-group">
                           <label className="form-label" htmlFor="descricao"><FormattedMessage id="home.modal_situ.label2"/><span className="form-required">*</span></label>
                           <textarea
                              className={`form-input ${ errors.descricao && touched.descricao ? 'is-invalid' : '' }`}
                              placeholder={placeholder1}
                              type="text"
                              name="descricao"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.descricao}
                              required
                           ></textarea>
                        </div>
                     </div>

                     <div className="col-md-12">
                        <div className="form-group">
                           <label className="form-label" htmlFor="endereco"><FormattedMessage id="home.modal_situ.label13"/><span className="form-required">*</span></label>
                           <input
                              className={`form-input ${ errors.endereco && touched.endereco ? 'is-invalid' : '' }`}
                              placeholder={placeholder5}
                              type="text"
                              name="endereco"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.endereco}
                              required
                           />
                        </div>
                     </div>

                     <div className="col-md-6">
                        <div className="form-group">
                           <label className="form-label" htmlFor="data"><FormattedMessage id="home.modal_situ.label3"/><span className="form-required">*</span></label>
                           <input
                              className={`form-input ${ errors.data && touched.data ? 'is-invalid' : '' }`}
                              type="date"
                              name="data"
                              placeholder="dd/mm/yy"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.data}
                           />
                        </div>
                     </div>

                     <div className="col-md-6">
                        <div className="form-group">
                           <label className="form-label" htmlFor="periodo"><FormattedMessage id="home.modal_situ.label4"/><span className="form-required">*</span></label>
                           <select
                              className={`form-input ${ errors.periodo && touched.periodo ? 'is-invalid' : '' }`}
                              name="periodo"
                              placeholder="Periodo"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.periodo}
                           >
                              <option value="Manhã">{ intl.formatMessage({id: "home.modal_situ.option12"}) }</option>
                              <option value="Tarde">{ intl.formatMessage({id: "home.modal_situ.option13"}) }</option>
                              <option value="Noite">{ intl.formatMessage({id: "home.modal_situ.option14"}) }</option>
                           </select>
                        </div>
                     </div>

                     <div className="col-md-6">
                        <div className="form-group">
                           <label className="form-label" htmlFor="idade"><FormattedMessage id="home.modal_situ.label5"/><span className="form-required">*</span></label>
                           <input
                              className={`form-input ${ errors.idade && touched.idade ? 'is-invalid' : '' }`}
                              type="number"
                              name="idade"
                              placeholder={placeholder2}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.idade}
                           />
                        </div>
                     </div>

                     <div className="col-md-6">
                        <div className="form-group">
                           <label className="form-label" htmlFor="renda"><FormattedMessage id="home.modal_situ.label6"/><span className="form-required">*</span></label>
                           <select
                              className={`form-input ${ errors.renda && touched.renda ? 'is-invalid' : '' }`}
                              name="renda"
                              placeholder="Renda"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.renda}
                           >
                              <option value="B1">{ intl.formatMessage({id: "home.modal_situ.option15"}) }</option>
                              <option value="B2">{ intl.formatMessage({id: "home.modal_situ.option16"}) }</option>
                              <option value="B3">{ intl.formatMessage({id: "home.modal_situ.option17"}) }</option>
                              <option value="B4">{ intl.formatMessage({id: "home.modal_situ.option18"}) }</option>
                              <option value="B5">{ intl.formatMessage({id: "home.modal_situ.option19"}) }</option>
                              <option value="B6">{ intl.formatMessage({id: "home.modal_situ.option20"}) }</option>
                           </select>
                        </div>
                     </div>

                     <div className="col-md-6">
                        <div className="form-group">
                           <label className="form-label" htmlFor="escolaridade"><FormattedMessage id="home.modal_situ.label7"/><span className="form-required">*</span></label>
                           <select
                              className={`form-input ${ errors.escolaridade && touched.escolaridade ? 'is-invalid' : '' }`}
                              name="escolaridade"
                              placeholder="Escolaridade"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.escolaridade}
                           >
                              <option value="C1">{ intl.formatMessage({id: "home.modal_situ.option21"}) }</option>
                              <option value="C2">{ intl.formatMessage({id: "home.modal_situ.option22"}) }</option>
                              <option value="C3">{ intl.formatMessage({id: "home.modal_situ.option23"}) }</option>
                              <option value="C4">{ intl.formatMessage({id: "home.modal_situ.option24"}) }</option>
                              <option value="C5">{ intl.formatMessage({id: "home.modal_situ.option25"}) }</option>
                              <option value="C6">{ intl.formatMessage({id: "home.modal_situ.option26"}) }</option>
                              <option value="C7">{ intl.formatMessage({id: "home.modal_situ.option27"}) }</option>
                              <option value="C8">{ intl.formatMessage({id: "home.modal_situ.option28"}) }</option>
                              <option value="C9">{ intl.formatMessage({id: "home.modal_situ.option29"}) }</option>
                              <option value="C10">{ intl.formatMessage({id: "home.modal_situ.option30"}) }</option>
                              <option value="C11">{ intl.formatMessage({id: "home.modal_situ.option31"}) }</option>
                              <option value="C12">{ intl.formatMessage({id: "home.modal_situ.option32"}) }</option>
                              <option value="C13">{ intl.formatMessage({id: "home.modal_situ.option33"}) }</option>
                           </select>
                        </div>
                     </div>

                     <div className="col-md-6">
                        <div className="form-group">
                           <label className="form-label" htmlFor="categoria"><FormattedMessage id="home.modal_situ.label8"/><span className="form-required">*</span></label>
                           <select
                              className={`form-input ${ errors.categoria && touched.categoria ? 'is-invalid' : '' }`}
                              name="categoria-profissional"
                              placeholder="Categoria Profissional"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.categoria}
                           >
                              <option value="D1">{ intl.formatMessage({id: "home.modal_situ.option34"}) }</option>
                              <option value="D2">{ intl.formatMessage({id: "home.modal_situ.option35"}) }</option>
                              <option value="D3">{ intl.formatMessage({id: "home.modal_situ.option36"}) }</option>
                              <option value="D4">{ intl.formatMessage({id: "home.modal_situ.option37"}) }</option>
                              <option value="D5">{ intl.formatMessage({id: "home.modal_situ.option38"}) }</option>
                              <option value="D6">{ intl.formatMessage({id: "home.modal_situ.option39"}) }</option>
                              <option value="D7">{ intl.formatMessage({id: "home.modal_situ.option40"}) }</option>
                              <option value="D8">{ intl.formatMessage({id: "home.modal_situ.option41"}) }</option>
                              <option value="D10">{ intl.formatMessage({id: "home.modal_situ.option43"}) }</option>
                              <option value="D11">{ intl.formatMessage({id: "home.modal_situ.option44"}) }</option>
                              <option value="D12">{ intl.formatMessage({id: "home.modal_situ.option45"}) }</option>
                              <option value="D13">{ intl.formatMessage({id: "home.modal_situ.option46"}) }</option>
                              <option value="D14">{ intl.formatMessage({id: "home.modal_situ.option47"}) }</option>
                              <option value="D15">{ intl.formatMessage({id: "home.modal_situ.option48"}) }</option>
                              <option value="D16">{ intl.formatMessage({id: "home.modal_situ.option49"}) }</option>
                              <option value="D17">{ intl.formatMessage({id: "home.modal_situ.option50"}) }</option>
                              <option value="D18">{ intl.formatMessage({id: "home.modal_situ.option51"}) }</option>
                              <option value="D19">{ intl.formatMessage({id: "home.modal_situ.option52"}) }</option>
                              <option value="D20">{ intl.formatMessage({id: "home.modal_situ.option53"}) }</option>
                              <option value="D21">{ intl.formatMessage({id: "home.modal_situ.option54"}) }</option>
                              <option value="D22">{ intl.formatMessage({id: "home.modal_situ.option55"}) }</option>
                              <option value="D23">{ intl.formatMessage({id: "home.modal_situ.option56"}) }</option>
                              <option value="D24">{ intl.formatMessage({id: "home.modal_situ.option57"}) }</option>
                              <option value="D25">{ intl.formatMessage({id: "home.modal_situ.option58"}) }</option>
                              <option value="D26">{ intl.formatMessage({id: "home.modal_situ.option59"}) }</option>
                           </select>
                        </div>
                     </div>

                     <div className="col-md-6">
                        <div className="form-group">
                           <label className="form-label" htmlFor="sexo"><FormattedMessage id="home.modal_situ.label9"/><span className="form-required">*</span></label>
                           <select
                              className={`form-input ${ errors.sexo && touched.sexo ? 'is-invalid' : '' }`}
                              name="sexo"
                              placeholder="Sexo"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.sexo}
                           >
                              <option value="E1">{ intl.formatMessage({id: "home.modal_situ.option60"}) }</option>
                              <option value="E2">{ intl.formatMessage({id: "home.modal_situ.option61"}) }</option>
                              <option value="E3">{ intl.formatMessage({id: "home.modal_situ.option62"}) }</option>
                           </select>
                        </div>
                     </div>

                     <div className="col-md-6">
                        <div className="form-group">
                           <label className="form-label" htmlFor="cor"><FormattedMessage id="home.modal_situ.label10"/><span className="form-required">*</span></label>
                           <select
                              className={`form-input ${ errors.cor && touched.cor ? 'is-invalid' : '' }`}
                              name="cor"
                              placeholder="Cor"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.cor}
                           >
                              <option value="F1">{ intl.formatMessage({id: "home.modal_situ.option63"}) }</option>
                              <option value="F2">{ intl.formatMessage({id: "home.modal_situ.option64"}) }</option>
                              <option value="F3">{ intl.formatMessage({id: "home.modal_situ.option65"}) }</option>
                              <option value="F2">{ intl.formatMessage({id: "home.modal_situ.option66"}) }</option>
                              <option value="F3">{ intl.formatMessage({id: "home.modal_situ.option67"}) }</option>
                              <option value="F2">{ intl.formatMessage({id: "home.modal_situ.option68"}) }</option>
                           </select>
                        </div>
                     </div>   
                  
                    <div className="col-md-12">
                        <div className="form-group">
                           <label className="form-label" htmlFor="email"><FormattedMessage id="home.modal_situ.label11"/><span className="form-required">*</span></label>
                           <input
                              className={`form-input ${ errors.nome && touched.nome ? 'is-invalid' : '' }`}
                              placeholder={placeholder3}
                              type="nome"
                              name="nome"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.nome}
                              required
                           />
                        </div>
                     </div>

                     <div className="col-md-12">
                        <div className="form-group">
                           <label className="form-label" htmlFor="email"><FormattedMessage id="home.modal_situ.label12"/><span className="form-required">*</span></label>
                           <input
                              className={`form-input ${ errors.email && touched.email ? 'is-invalid' : '' }`}
                              placeholder={placeholder4}
                              type="email"
                              name="email"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.email}
                              required
                           />
                        </div>
                     </div>
                   </div>
                  <p><FormattedMessage id="home.modal_situ.p2"/></p>
                  <button className="button button--primary" type="submit" disabled={isSubmitting}><FormattedMessage id="home.modal_situ.button"/></button>
               </form>
            )}
         </Formik>
      </div>
   )
}

export default injectIntl(withRouter(ModalSituacao));
